import React, { FC } from 'react';
import { FavoriteIcon_inactive } from '../../../../components/icons/OurIcons';
import { useLoginPrompt } from '../../../../components/common/LoginPromptContext';

type FavoriteTogglePublicProps = {
  propertyId: string;
  styleClassNames?: string;
}

const FavoriteTogglePublic: FC<FavoriteTogglePublicProps> = ({ styleClassNames = '' }) => {
  const { promptLogin } = useLoginPrompt();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    promptLogin({ message: 'Sign in to save favorites.' });
  };

  return (
    <div
      className={`cursor-pointer ${styleClassNames} flex justify-center relative group`}
      onClick={handleClick}
      title="Sign in to save favorites"
    >
      <FavoriteIcon_inactive />
      {/* Tooltip on hover */}
      <div className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
        Sign in to save favorites
      </div>
    </div>
  );
};

export default FavoriteTogglePublic;
